import { defineComponent } from 'vue';
import Image from '@hems/component/src/image/Image.vue';
export default defineComponent({
    name: 'DropdownMenu',
    components: { Image },
    props: {
        selectedValue: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['click'],
});
